export const POLLS_GROUP_NAME = 'registration'

export const REGISTRATION_POLLS = {
  NUMBER_OF_STAFFERS: 'registration_number_of_staffers',
  GOALS: 'registration_goals',
  OTHER_APPS: 'registration_other_apps',
  NUMBER_OF_APPOINTMENTS: 'registration_number_of_appointments',
}
